import React, { useState, useEffect } from 'react';

interface CounterAnimationProps {
  targetValue: string | number | undefined;
}

function formatNumber(value: number | undefined, n: number | undefined) {
  if (typeof value !== 'number') return '';
  const floor = Math.floor(n || 0);
  const numString = value.toFixed(Math.max(0, floor));
  const parts = numString.split('.');
  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  return parts.join('.');
}

const CounterAnimation: React.FC<CounterAnimationProps> = ({ targetValue }) => {
  const [counter, setCounter] = useState<number>(0);

  useEffect(() => {
    if (!targetValue) return;
    const numbersOnly = (value: string) => value.match(/\d+/g);
    const value = parseInt(numbersOnly(targetValue?.toString())?.join('') || '0', 10);

    // 애니메이션 시작
    const duration = 250;
    const startValue = counter;
    const stepDuration = 50;
    const steps = duration / stepDuration;
    const stepValue = (value - startValue) / steps;

    const intervalId = setInterval(() => {
      const newCounter = counter + stepValue;
      setCounter(newCounter);
      if (newCounter >= value) {
        clearInterval(intervalId);
      }
    }, stepDuration);

    return () => {
      clearInterval(intervalId);
    };
  }, [counter, targetValue]);

  if (!targetValue) return <></>;
  return <>{formatNumber(counter, 0)}</>;
};

export default CounterAnimation;
